var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 66,
    viewBox: "0 0 169 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 66,
    rx: 33,
    fill: "#B9B9B9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 33,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.638 46H102.258L89.1 26.008V46H86.72V22.234H89.1L102.258 42.192V22.234H104.638V46ZM120.705 46.238C118.506 46.238 116.511 45.728 114.721 44.708C112.93 43.6653 111.513 42.226 110.471 40.39C109.451 38.5313 108.941 36.4347 108.941 34.1C108.941 31.7653 109.451 29.68 110.471 27.844C111.513 25.9853 112.93 24.546 114.721 23.526C116.511 22.4833 118.506 21.962 120.705 21.962C122.926 21.962 124.932 22.4833 126.723 23.526C128.513 24.546 129.919 25.9853 130.939 27.844C131.959 29.68 132.469 31.7653 132.469 34.1C132.469 36.4347 131.959 38.5313 130.939 40.39C129.919 42.226 128.513 43.6653 126.723 44.708C124.932 45.728 122.926 46.238 120.705 46.238ZM120.705 44.164C122.473 44.164 124.059 43.756 125.465 42.94C126.87 42.124 127.981 40.9567 128.797 39.438C129.613 37.8967 130.021 36.1173 130.021 34.1C130.021 32.0827 129.613 30.3147 128.797 28.796C127.981 27.2773 126.87 26.11 125.465 25.294C124.059 24.478 122.473 24.07 120.705 24.07C118.937 24.07 117.35 24.478 115.945 25.294C114.539 26.11 113.429 27.2773 112.613 28.796C111.797 30.3147 111.389 32.0827 111.389 34.1C111.389 36.1173 111.797 37.8967 112.613 39.438C113.429 40.9567 114.539 42.124 115.945 42.94C117.35 43.756 118.937 44.164 120.705 44.164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/No.17cc69211590234b027f5ab00899b2d6.svg";
export { ForwardRef as ReactComponent };